<script lang="ts" setup>
import NothingFound from '@jaaluu/components/NothingFound.vue';
import TextWithTooltips from '@jaaluu/components/TextWithTooltips.vue';
import stores from '@jaaluu/stores';
import vuetify from '@jaaluu/vuetify';
import { t } from '@shared/i18n';
import sharedStores from '@shared/shared-stores';
import { onMounted, Ref, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const { TRANS } = stores.translate.consts;
const { favUrlsLang } = stores.favorites.state;
const { langForeign, langNative } = stores.language.state;
const { toggleFavoriteUrl } = stores.favorites.funcs;
const { getHumanizedDate } = sharedStores.datetime.funcs;

const headers: Ref<{ key: string; title: string; sortable?: boolean }[]> = ref([]);
const sortByUrls = ref([{ key: 'added_at', order: 'desc' }]);

onMounted(() => {
  setHeaders();
});

const setHeaders = () => {
  headers.value = [
    {
      key: 'actions',
      title: '',
      width: 50,
      sortable: false
    },
    {
      key: 'title',
      title: t('favorites.title'),
      sortable: true
    }
  ];
};

const iconMapping = {
  videos: 'mdi-youtube',
  feeds: 'mdi-newspaper-variant-outline',
  wikipedia: 'mdi-wikipedia',
  kids_lexicon: 'mdi-teddy-bear',
  books: 'mdi-book-open-variant-outline'
};

const readOrView = (url: string) => {
  router.push(url);
};

watch(
  () => langForeign.value,
  () => {
    setHeaders();
  }
);
</script>
<template>
  <div class="pa-2" v-if="langForeign">
    <NothingFound v-if="favUrlsLang.length === 0" :t_key="'favorites.no_favorites_found'" />
    <div v-else>
      <v-data-table-virtual
        :items="favUrlsLang"
        :headers="headers"
        v-model:sort-by="sortByUrls"
        hide-default-footer
        density="comfortable"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
            :prepend-icon="iconMapping[item.type]"
            @click="() => readOrView(item.url)"
            size="x-small"
            variant="text"
            color="green"
            class=""
            >{{ t(`general.${item.type === 'videos' ? 'view' : 'read'}`) }}</v-btn
          >
        </template>
        <template v-slot:item.title="{ item }">
          <div
            class="d-flex align-center justify-space-between height-fav-url grab"
            @click="() => readOrView(item.url)"
          >
            <div class="d-flex align-center">
              <div class="">
                <TextWithTooltips
                  :text="item.title"
                  :max-words="vuetify.display.mdAndUp.value ? 30 : 5"
                />
                <span class="subtitle-sm mt-n2"
                  >{{ TRANS[langForeign].general[item.type] }} -
                  {{ getHumanizedDate(item.added_at.toString(), langNative!) }}</span
                >
              </div>
            </div>
            <v-btn
              @click.stop="() => toggleFavoriteUrl(item.url, item.title, langForeign!)"
              size="x-small"
              variant="text"
              color="grey"
              icon="mdi-close"
            />
          </div>
        </template>
      </v-data-table-virtual>
    </div>
  </div>
</template>

<style scoped lang="scss">
.flag-icon {
  width: 25px;
}
.not-found-img {
  width: 100px;
}
.height-fav-url {
  height: 80px;
}
</style>
